// API endpoints configuration
export const API_ENDPOINTS = {
  // Auth endpoints
  auth: {
    login: "/auth/login/",
    logout: "/logout/",
    forgotPassword: "/auth/forgot-password/",
    resetPassword: "/auth/reset-password/",
    profile: "/user-profile/",
  },

  // User endpoints
  users: {
    base: "/users",
    profile: "/users/profile",
    updateProfile: "/users/profile",
    changePassword: "/users/change-password",
  },

  // Utility endpoints
  utility: {
    getUtility: "/api/user/get-utility/",
  },
  communicationTemplate: {
    getTemplate:
      "https://api-notification-dev.bynry.com/api/notification/template/",
  },
  communicationMessaging: {
    sendSingleMessage:
      "https://api-notification-dev.bynry.com/api/notification/direct-message/",
    sendBulkMessage:
      "https://api-notification-dev.bynry.com/api/notification/bulk-notification/",
    getRecipientTypes:
      "https://api-notification-dev.bynry.com/api/notification/choices/recipient_type/",
    getChannelTypes:
      "https://api-notification-dev.bynry.com/api/notification/choices/channel_type/",
    getRecipientLists:
      "https://api-notification-dev.bynry.com/api/notification/get-lists/",
  },
  communicationHistory: {
    getHistory:
      "https://api-notification-dev.bynry.com/api/notification/notifications/",
  },
  // Dashboard endpoints
  communicationDashboard: {
    listOverview:
      "https://api-notification-dev.bynry.com/api/notification/dashboard/list-overview/",
    overview:
      "https://api-notification-dev.bynry.com/api/notification/dashboard/overview/",
    channelPerformance:
      "https://api-notification-dev.bynry.com/api/notification/dashboard/channel-performance/",
    workflowPerformance:
      "https://api-notification-dev.bynry.com/api/notification/dashboard/workflow-performance/",
    workflowStats:
      "https://api-notification-dev.bynry.com/api/notification/dashboard/workflow-stats/",
    channelStats:
      "https://api-notification-dev.bynry.com/api/notification/dashboard/channel-stats/",
  },
  // Communication Lists endpoints
  communicationLists: {
    base: "https://api-notification-dev.bynry.com/api/notification/recipient-lists/",
    consumerData:
      "https://api-notification-dev.bynry.com/api/notification/fetch-consumer-data/",
    categoryConfig:
      "https://api-onboarding-dev.bynry.com/api/onboarding/config-map/category_json/",
    territoryConfig:
      "https://api-onboarding-dev.bynry.com/api/onboarding/config-map/territory_json/",
    recipientData:
      "https://api-notification-dev.bynry.com/api/notification/recipient-lists/recipients-data/",
    fetchContacts:
      "https://api-notification-dev.bynry.com/api/notification/fetch-consumer-data/",
    recipientLists:
      "https://api-notification-dev.bynry.com/api/notification/recipient-lists/",
  },
  // NEW: Communication Workflow endpoints
  communicationWorkflow: {
    base: "https://api-notification-dev.bynry.com/api/notification/workflow/",
    clone:
      "https://api-notification-dev.bynry.com/api/notification/workflow-clone/",
    runs: "https://api-notification-dev.bynry.com/api/notification/notification-run/",
    notifications:
      "https://api-notification-dev.bynry.com/api/notification/notifications/",
  },

  // Add more endpoint categories as needed
  // Example:
  // products: {
  //   base: '/products',
  //   categories: '/products/categories',
  // },
} as const;

// Type for API endpoints
export type ApiEndpoint = typeof API_ENDPOINTS;

// Helper function to get full endpoint URL
export const getEndpoint = (path: string): string => {
  return path.startsWith("http")
    ? path
    : `${import.meta.env.VITE_API_BASE_URL}${path}`;
};
